export const works = [
  {
    title: "Tienda de pasteles",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/tiendaPasteles/",
    codeLink: "https://github.com/EmaaxD/tiendaPasteles",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1596926592/jbbyirgmbnvgwuelomlq.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Agencia de autos",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/carDearleship/",
    codeLink: "https://github.com/EmaaxD/carDearleship",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1596926674/oxidji0e4tkixibcaboc.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Renta de casas",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/rentaCasas/",
    codeLink: "https://github.com/EmaaxD/rentaCasas",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1596926803/grtvtdbyotqy2xvv39mz.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Template Social Medial",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas.",
    projectLink: "https://emaaxd.github.io/red-social/",
    codeLink: "https://github.com/EmaaxD/red-social",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1596927041/svuzvdofu5eqcj1rcatr.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Cafe HeadNoise",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas.",
    projectLink: "https://emaaxd.github.io/restauranteCafe/",
    codeLink: "https://github.com/EmaaxD/restauranteCafe",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1596927082/gu2nzp5gio9vyd8e0adt.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Clon BruBank ARG",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/clone_bry/",
    codeLink: "https://github.com/EmaaxD/clone_bry",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1657552112/Captura_pfwpxg.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Card List Glass",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas.",
    projectLink: "https://emaaxd.github.io/card__glass/",
    codeLink: "https://github.com/EmaaxD/card__glass",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656460920/Captura_w7bhio.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "App Hoteles",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/hoteles/",
    codeLink: "https://github.com/EmaaxD/hoteles",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656461072/Captura_cyjvvq.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "App Instabroo",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/instabro/",
    codeLink: "https://github.com/EmaaxD/instabro",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656461222/Captura_fjicbp.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Clon UI Iphone xs",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/iphone_pa/",
    codeLink: "https://github.com/EmaaxD/iphone_pa",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656461361/Captura_jdvimi.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Landing Page",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: Bootstrap",
    projectLink: "https://emaaxd.github.io/project_personal_b2/",
    codeLink: "https://github.com/EmaaxD/project_personal_b2",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656461519/Captura_dlsvdz.png",
    tags: ["UI/UX", "All"],
  },
  {
    title: "Blog React",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API",
    projectLink: "https://ecstatic-ride-6dab68.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462026/Captura_swddeq.png",
    tags: ["Web App", "All"],
  },
  {
    title: "MERN Stack",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho con el stack MERN",
    projectLink: "https://jolly-bhabha-7c8297.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462084/Captura_h0fd7o.png",
    tags: ["Web App", "All"],
  },
  {
    title: "Covid-19 Tracking",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API, MUI y Covid API",
    projectLink: "https://unruffled-wright-d1ac7b.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462231/Captura_gz3hh1.png",
    tags: ["Web App", "All"],
  },
  {
    title: "React Insta Clon",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho con el stack MERN",
    projectLink: "https://quizzical-mcclintock-20c435.netlify.app/signin",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462254/Captura_frlkcg.png",
    tags: ["Web App", "All"],
  },
  {
    title: "React Get Weather",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API y API Clima",
    projectLink: "https://awesome-hugle-f88b1d.netlify.app",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462496/Captura_qt4dk9.png",
    tags: ["Web App", "All"],
  },
  {
    title: "React Paciente Veterinaria",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API y TailwindCSS",
    projectLink: "https://dynamic-treacle-cb1842.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462646/Captura_kybswy.png",
    tags: ["Web App", "All"],
  },
  {
    title: "React Reel Insta",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API.",
    projectLink: "https://strong-duckanoo-c16547.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462670/Captura_aqawbl.png",
    tags: ["Web App", "All"],
  },
  {
    title: "React Google Clon",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API, Google API, MUI y Firebase",
    projectLink: "https://cheerful-malabi-4343a5.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462779/Captura_yob8ec.png",
    tags: ["Web App", "All"],
  },
  {
    title: "React AnimeFLV Clon",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas. Hecho en: React, React Hooks, Context API, Firebase login, Firebase Database y MUI.",
    projectLink: "https://classy-cupcake-b5eabf.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656462800/Captura_whkdqm.png",
    tags: ["Web App", "All"],
  },
  {
    title: "Lol Clon",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas.",
    projectLink: "https://lol-clone.vercel.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1657188172/Captura_gj8tgu.png",
    tags: ["Web App", "All"],
  },
  {
    title: "Gif Expert Rework",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas.",
    projectLink: "https://preeminent-faun-b8e80d.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1657188219/Captura_xdpckb.png",
    tags: ["Web App", "All"],
  },
  {
    title: "Cotizador GyB",
    description:
      "Proyecto que fue realizado en mi anterior trabajo, hecho en: React, React Hooks, Context API, MUI.",
    projectLink: "https://cotizador.gilbertybolona.com/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1657196616/Captura_oaeloi.png",
    tags: ["Web App", "All"],
  },
  {
    title: "CandiTickets",
    description:
      "Proyecto para un freelo y con futuras implementaciones, hecho en: NextJs,TailwindCSS.",
    projectLink: "https://candi-tickets-4i3d7utd8-emaaxd.vercel.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1656463091/Captura_tjg3pn.png",
    tags: ["Web App", "All"],
  },
  {
    title: "Control Presupuesto",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas.",
    projectLink: "https://stupendous-malasada-63f82f.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1657360266/Captura_tygqtv.png",
    tags: ["Web App", "All"],
  },
  {
    title: "CRUD Firebase",
    description:
      "Proyecto personal con la intención de mejorar habilidades e implementar cosas nuevas, hecho en: ReactJS, React Hooks, Context API, TailwindCSS, Firebase Login, Firebase Database y Firebase Storage",
    projectLink: "https://enchanting-zuccutto-3f2006.netlify.app/",
    codeLink: "https://github.com/EmaaxD",
    image:
      "https://res.cloudinary.com/dpxrsbtae/image/upload/v1657647667/Captura_nvzesw.png",
    tags: ["Web App", "All"],
  },
];
